import styled from "@emotion/styled";
import { Box, Switch, Typography } from "@mui/material";
import { colors } from '../Theme/tokens';

const StyledTypography = styled(Typography)({
  color: colors.text.primary,
  fontWeight: 500,
});

const IOSSwitch = styled((SwitchProps) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...SwitchProps}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: colors.background.paper,
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? colors.secondary.main : colors.primary.main,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: colors.primary.main,
      border: `6px solid ${colors.background.paper}`,
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? colors.border.default : colors.primary.main,
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export const ToggleComponent = ({ isToggle, handleToggleChange,disabled=false, labelText, notificationLabel=false, notificationTopicId=null }) => {
    const getNotificationSubText = () => {
        switch (notificationTopicId) {
            case 2:
                return "IPOs, ETFs, crypto listings"
            case 6:
                return "New feature, feature enhancement, feature removal"
            case 7:
                return "New product, product information updated, product removed"
        }
    }
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: colors.background.paper,
          alignItems:"center",
          boxShadow:`0px 1px 5px 0px #00000026`,
          p:"24px",
          borderRadius:"12px"
        }}
      >
        {(labelText && labelText !=='')  && 
        ( (notificationLabel && notificationTopicId) ? <Box>
            <StyledTypography sx={{fontSize:{xs:"14px", sm:"18px"}}}>{labelText}</StyledTypography>
            {getNotificationSubText() && <Typography sx={{color: colors.text.secondary, fontSize:{xs:"12px",sm:"14px"}}}>{getNotificationSubText()}</Typography>}
            <Typography sx={{color: isToggle ? colors.secondary.main : colors.error.main, fontSize:{xs:"12px",sm:"14px"}}}>{isToggle ? "Subscribed" : "Unsubscribed"}</Typography>
        </Box>  
        
        : <StyledTypography>{labelText}</StyledTypography>)
        }
        <Box>
          <IOSSwitch
            checked={isToggle}
            onChange={handleToggleChange}
            defaultValue={false}
            disabled={disabled}
          />
        </Box>
      </Box>
    </>
  );
};
